// extracted by mini-css-extract-plugin
export default {"container":"TeamItem_container__NR-kh","title":"TeamItem_title__jDR-e"};